import { VNode } from 'vue'
import { Component, Vue, Ref } from 'vue-property-decorator'

import FieldsTable from './components/FieldsTable'
import CreateForm from './components/CreateForm'
import EditForm from './components/EditForm'

import { FormFieldManageServiceProxy, FormFieldDto } from '@/service-proxies/app-v2/dnc.service-proxies'
import { BaseView } from '@/mixins/Base'
const ffmsp = new FormFieldManageServiceProxy()
const CODE = 'DNC_RESOURCE'

@Component({
  components: {
    FieldsTable,
    CreateForm
  }
})
export default class ResourceFields extends BaseView<FormFieldDto> {
  @Ref() readonly createForm: CreateForm
  @Ref() readonly editForm: EditForm
  currentRecord = new FormFieldDto()
  tableDataX = [];
  tableData = [];

  created() {
    this.loadTableData()
  }

  async loadTableData() {
    try {
      this.tableLoading = true
      const res = await ffmsp.findFieldList(CODE)
      this.tableData = res

      let dataLength = res.length;
      let copy = JSON.parse(JSON.stringify(res));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }
      
      this.tableDataX = JSON.parse(JSON.stringify(copy));


      this.tableLoading = false
    } catch (e) {
      this.tableLoading = false
    }
  }

  handleCreate() {
    const { form } = this.createForm.dForm
    const { pairs } = this.createForm
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.modalLoading = true
          await ffmsp.create(CODE, { ...values, isSystem: false, dataSource: pairs })
          this.modalLoading = false
          this.modalVisible = false
          this.$message.success(this.$t('page_resource_pool_success'))
          await this.loadTableData()
        } catch (e) {
          this.modalLoading = false
        }
      }
    })
  }

  handleEdit() {
    const { form } = this.editForm.dForm
    const { pairs } = this.editForm
    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          this.drawerLoading = true
          const body = { ...this.currentRecord, ...values, dataSource: pairs }
          delete body.index
          await ffmsp.update(CODE, body)
          this.drawerLoading = false
          this.drawerVisible = false
          this.$message.success(this.$t('page_resource_pool_success'))
          await this.loadTableData()
        } catch (e) {
          this.drawerLoading = false
        }
      }
    })
  }

  async handleDelete() {
    try {
      this.tableLoading = true
      await ffmsp.remove(this.currentRecord.code, CODE)
      await this.loadTableData()
      this.$message.success(this.$t('page_resource_pool_success'))
    } catch (error) {
      this.tableLoading = false
    }
  }

  onAct(action) {
    this.currentRecord = action.payload
    if (action.type === 'edit') {
      if(this.drawerVisible) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.drawerVisible = true
          },
          onCancel() {
            return
          },
        });
      }else {
        this.drawerVisible = true
      }
    }
    if (action.type === 'delete') {
      this.handleDelete()
    }
  }

  render(): VNode {
    return (
      <div>
        <div style="margin-bottom: 16px;">
          <a-button
            v-acl={'page_setting_resource_create'}
            type="primary"
            style="margin-right: 16px;"
            onClick={() => (this.modalVisible = true)}
          >
            {this.$t('page_resource_pool_new_field')}
          </a-button>
        </div>
        <FieldsTable dataX={this.tableDataX} data={this.tableData} loading={this.tableLoading} onAct={this.onAct} />
        <a-modal
          title={this.$t('edit')}
          onCancel={() => (this.drawerVisible = false)}
          visible={this.drawerVisible}
          getContainer={false}
          mask={false}
          destroyOnClose={true}
        >
          <EditForm ref="editForm" record={this.currentRecord} />
          <div
          slot="footer"
          >
            <a-button type="primary" loading={this.drawerLoading} onClick={this.handleEdit}>
              {this.$t('submit')}
            </a-button>
          </div>
        </a-modal>
        <a-modal
          title={this.$t('page_resource_pool_new_field')}
          v-model={this.modalVisible}
          onOk={this.handleCreate}
          confirmLoading={this.modalLoading}
          okText={this.$t('submit')}
          cancelText={this.$t('cancel')}
          destroyOnClose={true}
          maskClosable={false}
        >
          <CreateForm ref="createForm" />
        </a-modal>
      </div>
    )
  }
}
